<template>
  <!-- <ul class="group">
    <li class="item" v-for="item of moneyList" :key="item" @click="selectMoneyItem(item)">{{ item }}</li>
  </ul> -->
  <div class="group">
    <van-row gutter="5" style="margin-top: 1.33333vw">
      <van-col span="12" @click="selectMoneyItem(100)"><div class="item">₡100</div></van-col>
      <van-col span="12" @click="selectMoneyItem(300)"><div class="item">₡300</div></van-col>
    </van-row>
    <van-row gutter="10" style="margin-top: 1.33333vw">
      <van-col span="12" @click="selectMoneyItem(500)"><div class="item">₡500</div></van-col>
      <van-col span="12" @click="selectMoneyItem(1000)"><div class="item">₡1000</div></van-col>
    </van-row>
    <van-row gutter="10" style="margin-top: 1.33333vw">
      <van-col span="12" @click="selectMoneyItem(1500)"><div class="item">₡1500</div></van-col>
      <van-col span="12" @click="selectMoneyItem(2000)"><div class="item">₡2000</div></van-col>
    </van-row>
    <van-row gutter="10" style="margin-top: 1.33333vw">
      <van-col span="12" @click="selectMoneyItem(3000)"><div class="item">₡3000</div></van-col>
      <van-col span="12" @click="selectMoneyItem(5000)"><div class="item">₡5000</div></van-col>
    </van-row>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';
// const moneyList = ref([100, 300, 500, 1000, 1500, 2000, 3000, 5000]);
const emit = defineEmits('onSelectMoneyItem');
const selectMoneyItem = (item) => {
  emit('onSelectMoneyItem', item);
};
</script>

<style lang="scss" scoped>
.group {
  padding: 10px;
  box-sizing: border-box;
  .item {
    background-color: #f8fff9;
    height: 75px;
    text-align: center;
    line-height: 75px;
    border-radius: 8px;
    box-shadow: 2px 2px #e5e5e5;
  }
}
</style>
